import classNames from 'classnames';
import React from 'react';
import type { ElementProps } from '../element/Element';
import { Element } from '../element/Element';
import styles from './Elevation.module.scss';

export interface Props extends ElementProps {
  /** When true, omits any typical styling like background/border/radius */
  plain?: boolean;
  /** Does this apply to an inline or floating element? @default `inline` */
  context?: 'inline' | 'floating';
  /** How deep is the shadow? @default `medium` */
  depth?: 'low' | 'medium' | 'high';
  /** How big is this elevation container? Controls border-radius @default `medium` */
  size?: 'small' | 'medium' | 'large';
}

/**
 * Simple Elevation component, build on `Element` with all the same props.
 * Works great as containers for dropdowns/popovers/tooltips/etc.
 */
const ElevationBase = (props: Props) => {
  const { plain = false, size = 'medium', context = 'floating', depth = 'medium', ...rest } = props;
  return (
    <Element
      as="div"
      {...rest}
      className={classNames(
        styles[`context--${context}`],
        styles[`depth--${depth}`],
        styles[`size--${size}`],
        { [styles.elevationBase]: !plain },
        props.className
      )}
    />
  );
};

ElevationBase.displayName = 'Elevation';

export const Elevation = ElevationBase;

// If we start exporting more from here...
// export const Elevation = Object.assign(ElevationBase, {});
